import React, { type ComponentType, lazy, Suspense } from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';

import type { CreateTeamDialogWrapperProps } from './main';

const CreateTeamDialogSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_create-team-dialog" */ './main'
		),
);

const LazyCreateTeamDialogNext = (props: CreateTeamDialogWrapperProps): React.ReactElement => (
	<Suspense fallback={null}>
		<CreateTeamDialogSuspense {...props} />
	</Suspense>
);

const LazyCreateTeamDialogLegacy: ComponentType<CreateTeamDialogWrapperProps> &
	Loadable.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_create-team-dialog" */ './main'
		),
	loading: () => null,
});
LazyCreateTeamDialogLegacy.displayName = 'lazy(CreateTeamDialog)';

const LazyCreateTeamDialog = (props: CreateTeamDialogWrapperProps): React.ReactElement =>
	fg('teams_app_react_19_upgrade') ? (
		<LazyCreateTeamDialogNext {...props} />
	) : (
		<LazyCreateTeamDialogLegacy {...props} />
	);

export default LazyCreateTeamDialog;
